let offsetNews;
let containerForBtnNews = document.querySelector("#more_news");
let btnNewsLoadMore = document.querySelector("#btn_more_news");

if (typeof btnNewsLoadMore != "undefined" && btnNewsLoadMore != null) {
  btnNewsLoadMore.addEventListener("click", function () {
    offsetNews = btnNewsLoadMore.getAttribute("data-offset");
    console.log("get offset btn", offsetNews);
    let dataProduct = btnNewsLoadMore.getAttribute("data-product");
    getDataNews(offsetNews, dataProduct);
  });
}

function setNewsItem(html) {
    let blockNews = document.querySelector("#block_news");
    blockNews && blockNews.insertAdjacentHTML("beforeend", html);
}
function getDataNews(offset, product) {
  const request = new XMLHttpRequest();
  const url = "/news/product/load-more";
  const params =
    "offset=" +
    offset +
    "&product=" +
    product +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log(request.responseText);
        let response = JSON.parse(request.responseText);
        if(response.status === "ok") {
          setNewsItem(response.html);
          if (
            response.showLoadMore === false ||
            response.showLoadMore === "false"
          ) {
            containerForBtnNews.classList.add("hide");
          } else {
            console.log("get offset response", response.offset);
            btnNewsLoadMore.setAttribute("data-offset", response.offset);
          }
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

function setHeightImgNews() {
  let arrayImgsNews = document.querySelectorAll(".item_news_img"); 
  let imgNewsEl = document.querySelector(".item_news_img");
  if(imgNewsEl !== null) {
    let currentWidth = window.screen.width;
    if((650 <= currentWidth) && (currentWidth <= 992)) {
      arrayImgsNews.forEach(element => {
        element.style.height = "230px";
      });
    } else {
      let newHeight = (imgNewsEl.offsetWidth / 4) * 3;
      arrayImgsNews.forEach(element => {
        element.style.height = `${newHeight}px`;
      });
    }
  }
}

setHeightImgNews();

window.addEventListener('resize', () => {
  setHeightImgNews();
});